import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../data/translations';
import { Cog, Package, Clock, ClipboardList, Search, Users } from 'lucide-react';

const iconMap = {
  Cog, Package, Clock, ClipboardList, Search, Users,
};

const ServicesSection = () => {
  const { lang } = useLang();

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] font-['Manrope'] mb-4">
            {t.services.overline[lang]}
          </span>
          <h2
            data-testid="services-title"
            className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] leading-tight max-w-xl"
          >
            {t.services.title[lang]}
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {t.services.items.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`p-8 md:p-10 border-[#E2E8F0] group hover:bg-[#F8FAFC] transition-colors duration-300
                  ${i % 3 !== 2 ? 'lg:border-r' : ''}
                  ${i < 3 ? 'border-b' : ''}
                  ${i % 2 !== 1 ? 'md:border-r lg:border-r-0' : 'md:border-r-0'}
                  ${i % 3 !== 2 ? 'lg:border-r' : 'lg:border-r-0'}
                  ${i < 4 ? 'md:border-b' : 'md:border-b-0'}
                  ${i < 3 ? 'lg:border-b' : 'lg:border-b-0'}
                  border
                  -mt-px -ml-px
                `}
              >
                <div className="w-10 h-10 flex items-center justify-center mb-6 border border-[#E2E8F0] group-hover:border-[#2563EB] transition-colors">
                  {Icon && <Icon className="w-5 h-5 text-[#334155] group-hover:text-[#2563EB] transition-colors" strokeWidth={1.5} />}
                </div>
                <h3 className="font-['Outfit'] text-lg md:text-xl font-semibold text-[#0F172A] mb-3 tracking-tight">
                  {item.title[lang]}
                </h3>
                <p className="font-['Manrope'] text-sm text-[#475569] leading-relaxed">
                  {item.desc[lang]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
